import React, {Component} from 'react';
import axios from 'axios';
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import FuseTheme from "../global/theme";
import {Card, CardTitle} from 'material-ui/Card';
import ActiveIcon from 'material-ui/svg-icons/action/thumb-up';
import AuditIcon from 'material-ui/svg-icons/content/content-paste';
import StoreIcon from 'material-ui/svg-icons/action/store';

/**
 * A component for displaying status data for Locations.
 *
 */
class LocationsStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            locationsList: [],
            totalActive: 0,
            totalAuditing: 0,
            totalOpen: 0,
        };
    }

    componentWillMount() {
        this.fetchData();
    }

    displayTotals = () => {
        const list = this.state.locationsList;
        const totals = {
            totalActive: 0,
            totalAuditing: 0,
            totalOpen: 0
        };
        if (list && list.length > 0) {
            const total = list.length;
            for (let i = 0; i < total; i++) {
                const item = list[i];
                if (item.active) {
                    totals.totalActive++;
                }
                if (item.is_auditing) {
                    totals.totalAuditing++;
                }
                if (item.is_open) {
                    totals.totalOpen++;
                }
            }
        }
        this.setState({
            totalActive: totals.totalActive,
            totalAuditing: totals.totalAuditing,
            totalOpen: totals.totalOpen,
        });
    };

    // Get all Locations
    fetchData() {
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "id", order: "ASC"}
        };
        const resource = locationResources.LocationsForStatus.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        this.setState({
                            locationsList: result.data.payload
                        });
                        this.displayTotals();
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        if (error.response.status && error.response.status === 401) {
                            checkTokenStatus();
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    render() {
        const styles = {
            icon: {float: 'right', width: 60, height: 60, padding: 16, color: FuseTheme.palette.correctColor},
            iconAlert: {color: FuseTheme.palette.accent1Color},
            row: {display: 'flex', textAlign: 'justify', justifyContent: 'space-between', textAlignLast: 'center'},
            statusCard: {flex: 1, display: 'inline-block', margin: '0 1em 2em 0', verticalAlign: 'top'},
            statusCardLast: {marginRight: '0'},
        };

        return (
            <div>
                {this.state.locationsList.length > 0 &&
                    <div style={styles.row}>
                        <Card style={styles.statusCard}>
                            <ActiveIcon style={styles.icon}/>
                            <CardTitle title={this.state.totalActive} subtitle="Active"/>
                        </Card>
                        < Card style={styles.statusCard}>
                            <StoreIcon style={styles.icon}/>
                            <CardTitle title={this.state.totalOpen} subtitle="Open"/>
                        </Card>
                        <Card style={{...styles.statusCard, ...styles.statusCardLast}}>
                            <AuditIcon style={{...styles.icon, ...styles.iconAlert}}/>
                            <CardTitle title={this.state.totalAuditing} subtitle="Auditing"/>
                        </Card>
                    </div>
                }
            </div>
        )
    }
}

export default LocationsStatus;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationsStatus.js